/**
 * The BCP 47 tag to format dates with, for the console's current language.
 *
 * Every page used to decide this inline with `language === 'zh' ? 'zh-TW' :
 * 'en-US'`. Traditional Chinese got Chinese dates and everything else got
 * American ones, so a console set to Japanese, Korean or Simplified Chinese
 * showed its dates in English in the middle of a translated page.
 */

const DATE_LOCALES: Record<string, string> = {
  en: 'en-US',
  zh: 'zh-TW',
  zh_CN: 'zh-CN',
  jp: 'ja-JP',
  ko: 'ko-KR',
}

export const DEFAULT_DATE_LOCALE = 'en-US'

export function dateLocaleFor(language: string | undefined): string {
  if (!language) return DEFAULT_DATE_LOCALE
  // i18next hands back the resolved language, but a region can still ride along
  // (en-GB, zh-Hant); fall back to the base before giving up.
  return (
    DATE_LOCALES[language] ??
    DATE_LOCALES[language.replace(/-/g, '_')] ??
    DATE_LOCALES[language.split(/[-_]/)[0]] ??
    DEFAULT_DATE_LOCALE
  )
}
